<template lang='pug'>
  v-flex(xs12, :title='component.label')
    v-radio-group(
      v-model="data",
      :label="t(this.id, component.label)",
      :placeholder="component.placeholder",
      :required="component.required",
      :disabled="component.disabled",
      :suffix="component.suffix",
      :prefix="component.prefix",
      :column="component.column",
      :row="component.row",
      hide-detail)
      v-radio(
        @mousedown="onHeaderColumnClick(item.value)"
        v-for="item in component.items"
        :key="item.value"
        :name="name"
        :label="item.text"
        :value="item.value"
        :color="item.color")
</template>

<script>
import { EventBus } from '@/event-bus'
export default {
  name: 'u-radio',

  props: {
    id: {
      type: String
    },
    name: {
      type: String
    },
    component: {
      type: Object,
      required: true
    },
    value: {}
  },

  watch: {
    value (val) {
      // if (this.component.items.find(item => item.value === val).length > 0) this.data = val
      this.data = val
    },
    data (val) {
      this.$emit('input', val)
      this.$emit('update', {key: this.name, value: val})
    },
    component (val) {
      if (val.items[0].default && !this.data) {
        const inputRadio = this.$el.getElementsByTagName('input')[0]
        if (inputRadio.value === val.items[0].value) {
          let valid = true
          document.getElementsByName(inputRadio.name).forEach(item => {
            if (item.checked === true) valid = false
          })

          if (valid) inputRadio.click()
        }
      }
    }
  },

  data () {
    return {
      data: null
    }
  },

  methods: {
    onHeaderColumnClick (val) {
      console.log(this.data, val, this.data === val)
      if (this.data === val) {
        setTimeout(() => {
          this.data = null
          let payload = []
          payload.push({ field: this.name, value: null })
          EventBus.$emit('eventField', { event: 'updateResultForm', val: payload })
        }, 500)
      } else this.onChange(val)
    }
  }
}
</script>

<style lang='stylus' scoped>
</style>



// WEBPACK FOOTER //
// src/components/form/inputs/Radio.vue